import {
  Text,
  Primary14ExtendedRegular,
  GreyGrey100,
  GreyGrey80,
  PrimaryHeader32Regular,
  Button,
  Link,
  AuthUI
} from '@sequencehq/core-components'

export const PkceExpectedCodeVerifierPage = () => {
  return (
    <AuthUI.Section gap="16px">
      <Text
        {...PrimaryHeader32Regular}
        textAlign="left"
        color={GreyGrey100}
        marginBottom="0px"
      >
        There seems to be a mix-up with your magic link
      </Text>
      <Text {...Primary14ExtendedRegular} color={GreyGrey80}>
        To keep your account secure, the magic link needs to be opened in the
        same browser or device where you started. Please try again.
      </Text>
      <Link
        to="/login"
        _hover={{
          textDecoration: 'none'
        }}
      >
        <Button
          variant="primary"
          fullWidth
          size="40px"
          style={{ fontSize: '14px', borderRadius: '8px' }}
        >
          Try again
        </Button>
      </Link>
    </AuthUI.Section>
  )
}

export default PkceExpectedCodeVerifierPage
